import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#steps" }),
    /*#__PURE__*/_createTextVNode(" Steps ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Guide the user to complete tasks in accordance with the process. Its steps can be set according to the actual application scenario and the number of the steps can't be less than 2. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIStepBarThatContainsStatus = _resolveComponent("EUIStepBarThatContainsStatus")
  const _component_EUICenter = _resolveComponent("EUICenter")
  const _component_EUIStepBarWithDescription = _resolveComponent("EUIStepBarWithDescription")
  const _component_EUIStepBarWithIcon = _resolveComponent("EUIStepBarWithIcon")
  const _component_EUIVerticalStepBar = _resolveComponent("EUIVerticalStepBar")
  const _component_EUISimpleStepBar = _resolveComponent("EUISimpleStepBar")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIStepBarThatContainsStatus),
    _createVNode(_component_EUICenter),
    _createVNode(_component_EUIStepBarWithDescription),
    _createVNode(_component_EUIStepBarWithIcon),
    _createVNode(_component_EUIVerticalStepBar),
    _createVNode(_component_EUISimpleStepBar)
  ], 64))
}